// document.addEventListener('DOMContentLoaded', function() {
//     const logoSplide = document.querySelector('.lc-splide');
//     if (logoSplide) {
//         new Splide(logoSplide, {
//             type   : 'loop',
//             perPage: 7,
//             perMove: 1,
//             autoplay: true,
//             interval: 2000,
//             gap: '1rem',
//             arrows    : false,
//             pagination: false,
//             breakpoints: {
//                 1024: { perPage: 5 },
//                 768 : { perPage: 4 },
//                 480 : { perPage: 2 },
//             },
//         }).mount();
//     }
// });

document.addEventListener('DOMContentLoaded', function() {
    const logoSplide = document.querySelector('.ics-splide');

    if (!logoSplide) { return; }

    const splide = new Splide(logoSplide, {
        type: 'fade',
        perPage: 1,
        autoplay: true,
        interval: 5000,
        speed: 1000,
        rewind: true,
        arrows: true,
        pagination: true,
        autoHeight: true,
        updateOnMove: true,
    });

    splide.on('mounted move', function() {
        const activeSlide = splide.Components.Elements.slides[splide.index];
        const track = splide.Components.Elements.track;

        track.style.height = activeSlide.offsetHeight + 'px';
    });

    splide.mount();
});